const introData = {
  name: "Solène PETTIER",
  title: "Senior Smart Contract / Protocol Engineer",
  tagline: "5+ years designing, building, and securing production blockchain systems — Solidity, Foundry, EVM architecture, DeFi protocols",
};

export default introData;
